export default __webpack_public_path__ + "svg/calendar/2026/6/septiembre.svg?8320cc76";